export default __webpack_public_path__ + "static/media/payment.71b55e41.png";